import { Center, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SourcingEventStatus, SourcingEventV2Dto } from "../../../../autogen/bff-api";
import { AwardOutcome } from "./AwardOutcome";
import { SelectWinner } from "./SelectWinner";

export const AwardTab = ({ event }: { event: SourcingEventV2Dto }) => {
  const { t } = useTranslation();

  switch (event.status) {
    case SourcingEventStatus.Evaluation:
      return <SelectWinner event={event} />;
    case SourcingEventStatus.AwardDecision:
    case SourcingEventStatus.Awarded:
      return <AwardOutcome event={event} />;
    default:
      return (
        <Center py="16">
          <Text color="smMuted">
            {t("Awarding becomes available once bidding is closed and bids are under evaluation.")}
          </Text>
        </Center>
      );
  }
};
